import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { TextLink as TextLink$1 } from '@vds/core';
import styles from './text-link.module.scss.js';

const TextLink = (props) => {
    const { bold, kind } = props, rest = __rest(props, ["bold", "kind"]);
    const textLinkStyles = [styles.textLinkWrapper];
    if (bold)
        textLinkStyles.push(styles.bold);
    return (jsx("span", { className: textLinkStyles.join(' '), children: jsx(TextLink$1, Object.assign({ kind: kind }, rest)) }));
};

export { TextLink as default };
